import React, { useCallback } from "react";
import { DropdownItem } from "reactstrap";

export const AddButtonOption = React.memo(
  ({ option, handleAddComponent, btnTitle }) => {
    const handleClick = useCallback(() => {
      handleAddComponent(option.parameters);
    }, [option.parameters, handleAddComponent]);

    return (
      <DropdownItem disabled={!option.enabled} onClick={handleClick}>
        {option.title || btnTitle}
      </DropdownItem>
    );
  },
);
